module.exports = __webpack_public_path__ + "static/media/profile_square.9e16f541.png";